import React, { useState } from 'react'
import { TableGrid } from 'components'
import { useIsSmallScreen } from 'packages/core'
import { Box } from '@mui/material'
import { CheckedIcon } from 'packages/eid-icons'
import { Pagination, ThresholdSearchInput } from 'packages/eid-ui'
import { useManagementRoleManagementRolesGranted } from 'hooks'
import { useTranslation } from 'react-i18next'

export const ManagementRolesGranted = ({ managementRole }: any) => {
    const take = 10
    const isSmallScreen = useIsSmallScreen()

    const { t } = useTranslation()
    const [page, setPage] = React.useState(1)
    const [perPageItems, setPerPageItems] = useState(take)
    const [searchKey, setSearchKey] = useState('')

    const handlePageChange = (_: any, value: any) => {
        setPage(value)
    }
    const handlePageSelection = (value: any) => {
        setPage(value)
    }
    const handleItemsPerPageChange = (value: any) => {
        setPage(1)
        setPerPageItems(value)
    }

    const handleSearchChange = (value: any) => {
        setPage(1)
        setSearchKey(value)
    }

    const { data } = useManagementRoleManagementRolesGranted(
        managementRole.id,
        (page - 1) * perPageItems,
        perPageItems,
        searchKey && encodeURIComponent(searchKey),
    )
    const list = data ? data.data : undefined

    const isInitialLoading = !Boolean(data)

    const numberOfPages = data ? Math.ceil(data.totalCount / perPageItems) : 0

    const attributes = [
        {
            label: '',
            resolve: () => <CheckedIcon />,
        },
        {
            label: t('Common_FriendlyName'),
            resolve: (item: any) => <> {item.friendlyName}</>,
        },
        {
            name: 'resourceSystemFriendlyName',
            label: t('Common_ResourceSystem'),
        },
    ]

    return (
        <>
            <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                padding="16px 32px 16px 32px"
                style={{ backgroundColor: '#ebebed' }}
            >
                <Box width={!isSmallScreen ? '308px' : '200px'}>
                    <ThresholdSearchInput
                        placeholder={'Common_Search'}
                        handleSearch={handleSearchChange}
                    />
                </Box>
            </Box>
            <TableGrid
                loading={isInitialLoading}
                data={list}
                attributes={attributes}
            />

            {!isInitialLoading && (
                <Box
                    padding={!isSmallScreen ? '20px 32px' : '16px'}
                    display="flex"
                    alignItems="center"
                    justifyContent={!isSmallScreen ? 'flex-start' : 'center'}
                >
                    <Pagination
                        count={numberOfPages}
                        size={!isSmallScreen ? 'large' : 'small'}
                        page={page}
                        onChange={handlePageChange}
                        totalCount={data?.totalCount}
                        onPageSelection={handlePageSelection}
                        itemsPerPage={perPageItems}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        showPageSelection={true}
                        showItemsPerPageSelection
                        showCountStat
                    />
                </Box>
            )}
        </>
    )
}
